<app>
    <template if={state.loginState == ''}>
        <login on-auth={ onUpdateAuth }/>
    </template>

    <template if={state.loginState == 'verify'}>
        <verify on-verify={ onUpdateAuth }/>
    </template>
    
    <template if={state.loginState == 'auth'}>
        <topnav></topnav>
        <div id="content-wrapper">
            <section id="today" class="section">
                <today></today>
            </section>
            <section id="weather" class="section" style="display: none;">
                <weather></weather>
            </section>
            <section id="home-controls" class="section" style="display: none;">
                <homectrl></homectrl>
            </section>
            <section id="blank" class="section" style="display: none;"></section>
        </div>

        <nav class="bottom-nav">
            <a href="#" class="active" data-target="today">
                <i class="fas fa-calendar-check fa-2x"></i>
                <span>Today</span> </a>
            <a href="#" data-target="weather">
                <i class="fas fa-cloud-sun fa-2x"></i>
                <span>Weather</span>
            </a>
            <a href="#" data-target="home-controls">
                <i class="fas fa-home fa-2x"></i>
                <span>Home Ctrl</span> </a>
        </nav>
    </template>
    
    <script>
        import lazy from '@riotjs/lazy';
        import { TOKEN_KEY } from '../lib/constants';

        function connectTabs() {
            const tabs = document.querySelectorAll('.bottom-nav a');
            const sections = document.querySelectorAll('#content-wrapper .section');
            const blankSection = document.querySelector('#blank');

            tabs.forEach(tab => {
                tab.addEventListener('click', (event) => {
                    event.preventDefault(); // Prevent page jump

                    tabs.forEach(t => t.classList.remove('active'));
                    tab.classList.add('active');

                    sections.forEach(section => section.style.display = 'none');
                    blankSection.style.display = 'block';
                    setTimeout(() =>{
                        document.getElementById(tab.dataset.target).style.display = 'block';
                        blankSection.style.display = 'none';
                    }, 25);
                    
                });
            });
        }

        export default {
            state: {
                loginState: ''
            },
            components: {
                topnav: lazy(() => import('./topnav.riot')),
                login: lazy(() => import('./login.riot')),
                verify: lazy(() => import('./verify.riot')),
                today: lazy(() => import('./today.riot')),
                weather: lazy(() => import('./weather.riot')),
                homectrl: lazy(() => import('./homectrl.riot')),
            },
            onMounted(props, state) {
                const token = localStorage.getItem(TOKEN_KEY);
                if(token) {
                    this.update({
                        loginState: 'auth'
                    });
                    connectTabs();
                }
            },
            onUpdateAuth(ev) {
                this.update({
                    loginState: ev.loginState
                });
                if(ev.loginState == 'auth') {
                    connectTabs();
                }
            }
        }
    </script>
</app>